import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { auth, db } from "../firebase";
import { signOut } from "firebase/auth";
import { updateDoc, doc } from "firebase/firestore";
import { AuthContext } from "../context/auth";
import { useHistory } from "react-router-dom";

const Navbar = () => {
  const history = useHistory();
  const { user } = useContext(AuthContext);

  const handleSignout = async () => {
    await updateDoc(doc(db, "users", auth.currentUser.uid), {
      isOnline: false,
    });
    await signOut(auth);
    history.replace("/login");
  };
  return (
    <nav>
      <h3>
        <Link to="/">английский класс</Link>
      </h3>
      <div>
        {user ? (
          <>
            <Link to="/profile">профиль</Link>
            <button className="btn" onClick={handleSignout}>
            выйти
            </button>
          </>
        ) : (
          <>
            <Link to="/register">регистр</Link>
            <Link to="/login">логин</Link>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
